import { Fade, Grid } from '@material-ui/core';
import { MainLayout } from '../../layouts';
import DashboardCard from './DashboardCard';
import DashboardDoughnut from './DoughnutChartCard';

export default function DashboardView(props) {
  return (
    <Fade in={true}>
      <div>
        <MainLayout>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <DashboardCard title="Bank Recon Balance" text="R1 200 000" />
            </Grid>
            <Grid item xs={4}>
              <DashboardCard title="Errors" text="20" />
            </Grid>
            <Grid item xs={4}>
              <DashboardCard title="Pending Batches" text="3" />
            </Grid>
            <Grid item xs={3}>
              <DashboardDoughnut title="Transactions" />
            </Grid>
          </Grid>
        </MainLayout>
      </div>
    </Fade>
  );
};